export enum IntakeType {
  mobile = 'Mobiel',
  fixed = 'Vast',
}
